/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './message/activate_experiment';
import './message/get_activate_experiment';
import './message/get_experiments';
import './message/track_event';
import './message/record_exclusion';
const $root = $protobuf.roots['square-experiments'] || ($protobuf.roots['square-experiments'] = new $protobuf.Root());
$root.addJSON({
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "experiments": {
                "nested": {
                  "ExperimentsService": {
                    "methods": {
                      "ActivateExperiment": {
                        "requestType": "squareup.feature.relay.experiments.message.ActivateExperimentRequest",
                        "responseType": "squareup.feature.relay.experiments.message.ActivateExperimentResponse"
                      },
                      "GetActivateExperiment": {
                        "requestType": "squareup.feature.relay.experiments.message.GetActivateExperimentRequest",
                        "responseType": "squareup.feature.relay.experiments.message.GetActivateExperimentResponse"
                      },
                      "GetExperiments": {
                        "requestType": "squareup.feature.relay.experiments.message.GetExperimentsRequest",
                        "responseType": "squareup.feature.relay.experiments.message.GetExperimentsResponse"
                      },
                      "TrackEvent": {
                        "requestType": "squareup.feature.relay.experiments.message.TrackEventRequest",
                        "responseType": "squareup.feature.relay.experiments.message.TrackEventResponse"
                      },
                      "RecordExclusion": {
                        "requestType": "squareup.feature.relay.experiments.message.RecordExclusionRequest",
                        "responseType": "squareup.feature.relay.experiments.message.RecordExclusionResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE ExperimentsService @ squareup/feature/relay/experiments/service.proto at 17:1
 */
export const ExperimentsService = $root.lookupService('squareup.feature.relay.experiments.ExperimentsService');